<template>
  <li class="dropdown guest-settings-dropdown" data-test="guest-settings-dropdown">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true">
      <span class="glyphicon glyphicon-cog"></span>
    </a>
    <ul class="dropdown-menu">
      <li v-if="props.showLinkToFoundationsSession">
        <a data-test="foundations-session-button" href="/foundations/"
          >Continue your Gyre journey</a
        >
      </li>
      <li><a data-test="my-account-button" href="/myaccount/">My Account</a></li>
      <li>
        <a data-test="log-off-button" tabindex="0" style="cursor: pointer" @click="logOff()">
          Log off
        </a>
      </li>
    </ul>
  </li>
</template>

<script setup lang="ts">
import logOut from "../services/utilities/log-out";

const props = defineProps<{
  showLinkToFoundationsSession: boolean;
}>();

function logOff(): void {
  logOut();
}
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";

.guest-settings-dropdown {
  display: flex;
  justify-content: center;
}
</style>
